import React, { memo } from "react";
import { NotFound } from "../common/NotFound";
import Spinner from "../common/Spinnner";

const ProductCategoryCard = memo(function ProductCategoryCard({
  item,
  fallbackImage,
  onSelect,
}) {
  const title = item?.shortDesc || item?.productName || "Product";
  const imageUrl = item?.imageUrl || fallbackImage;

  return (
    <button
      type="button"
      className="product-browser-card"
      title={title}
      onClick={() => onSelect(item)}
    >
      <span className="product-browser-image">
        <img src={imageUrl} alt={title} />
      </span>
      <span className="product-browser-title">{title}</span>
      <span className="product-browser-action" aria-hidden="true">
        <i className="fas fa-angle-right"></i>
      </span>
    </button>
  );
});

export const ProductCategoryBrowser = memo(function ProductCategoryBrowser({
  title,
  search,
  items = [],
  loading,
  fallbackImage,
  onBack,
  onSearch,
  onSearchChange,
  onClearSearch,
  onSelect,
  searchPlaceholder = "Search model name",
}) {
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  return (
    <div className="product-browser-shell">
      <div className="product-browser-toolbar">
        <div className="product-browser-title-wrap">
          <button
            type="button"
            className="product-browser-back"
            title="Back"
            aria-label="Back"
            onClick={onBack}
          >
            <i className="fas fa-angle-left"></i>
          </button>
          <div>
            <h2>{title}</h2>
            <span>{items?.length || 0} option{items?.length === 1 ? "" : "s"} available</span>
          </div>
        </div>

        <div className="product-browser-search">
          <i className="fas fa-search" aria-hidden="true"></i>
          <input
            id={`${title.replace(/\s+/g, "-").toLowerCase()}-search`}
            name={`${title.replace(/\s+/g, "-").toLowerCase()}Search`}
            type="text"
            placeholder={searchPlaceholder}
            value={search}
            onKeyDown={handleKeyDown}
            onChange={(event) => onSearchChange(event.target.value)}
          />
          {search && (
            <button
              type="button"
              className="product-browser-search-action"
              title="Clear search"
              aria-label="Clear search"
              onClick={onClearSearch}
            >
              <i className="fas fa-times"></i>
            </button>
          )}
          <button
            type="button"
            className="product-browser-search-action"
            title="Search"
            aria-label="Search"
            onClick={onSearch}
          >
            <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <div className="product-browser-grid">
        {items?.length > 0 ? (
          items.map((item, index) => (
            <ProductCategoryCard
              key={item?.id || item?.productGroupId || item?.productId || `${item?.shortDesc || item?.productName}-${index}`}
              item={item}
              fallbackImage={fallbackImage}
              onSelect={onSelect}
            />
          ))
        ) : loading ? (
          <div className="product-browser-state">
            <Spinner />
          </div>
        ) : (
          <div className="product-browser-state">
            <NotFound />
          </div>
        )}
      </div>
    </div>
  );
});
